import React from "react"
import {StripBannerProps} from "./models"
import {
    ThreeColumnContainer,
    SingleColumnContainer,
    ButtonText,
    ComponentContainer,
    StyledButton,
    StyledImage,
    StyledTypography,
    TextContainer,
    UnstyledLink,
} from "./components"
import {Text} from "../text"
import {COPY_TYPE, STRIP_TYPE, useUniqueKey, getSearchBannerComponentTestId} from "../utils"

export const StripBanner = ({overrideStyles, content, isIntelRecs}: StripBannerProps) => {
    const {components, text: textContent} = content
    const stripKeys = useUniqueKey(components?.length ?? 0)
    const textStyles = {
        textColor: overrideStyles?.textColor,
        fontWeight: overrideStyles?.fontWeight,
        textDecoration: overrideStyles?.textDecoration,
        fontSize: overrideStyles?.fontSize,
        textAlign: overrideStyles?.textAlign,
    }
    const bannerStyles = {
        backgroundColor: overrideStyles?.backgroundColor,
    }
    const buttonStyles = {
        borderColor: overrideStyles?.borderColor,
        borderRadius: overrideStyles?.borderRadius,
        buttonBackgroundColor: overrideStyles?.buttonBackgroundColor,
    }
    const buttonTextStyles = {
        buttonTextColor: overrideStyles?.buttonTextColor,
        buttonFontWeight: overrideStyles?.buttonFontWeight,
    }
    const linkStyles = {
        linkColor: overrideStyles?.linkColor,
        linkHoverColor: overrideStyles?.linkHoverColor,
        linkUnderline: overrideStyles?.linkUnderline,
        linkWeight: overrideStyles?.linkWeight,
    }

    let BannerContainer = SingleColumnContainer
    let singleColumn = true
    if (components?.length !== 1) {
        BannerContainer = ThreeColumnContainer
        singleColumn = false
    }
    return (
        <BannerContainer
            $bannerStyles={bannerStyles}
            data-testid={getSearchBannerComponentTestId(isIntelRecs, "strip")}
        >
            {textContent != null && textContent !== "" ? (
                <StyledTypography $textStyles={textStyles} $singleColumn>
                    <Text text={textContent} replacements={components} type={COPY_TYPE} />
                </StyledTypography>
            ) : (
                components?.map((component, idx) => {
                    const {image, text, url, accessibilityText, type} = component
                    if (image != null && image !== "") {
                        return (
                            <ComponentContainer key={stripKeys[idx]}>
                                <StyledImage src={image} alt={accessibilityText} />
                            </ComponentContainer>
                        )
                    }
                    if (type === "chip") {
                        return (
                            <ComponentContainer key={stripKeys[idx]}>
                                <UnstyledLink href={url}>
                                    <StyledButton $buttonStyles={buttonStyles}>
                                        <ButtonText $textStyles={buttonTextStyles}>{text}</ButtonText>
                                    </StyledButton>
                                </UnstyledLink>
                            </ComponentContainer>
                        )
                    }
                    return (
                        <TextContainer key={stripKeys[idx]} $singleColumn={singleColumn}>
                            <StyledTypography $textStyles={textStyles} $singleColumn={singleColumn}>
                                <Text
                                    text={text}
                                    replacements={[component]}
                                    linkStyles={linkStyles}
                                    type={STRIP_TYPE}
                                />
                            </StyledTypography>
                        </TextContainer>
                    )
                })
            )}
        </BannerContainer>
    )
}

export default StripBanner
